import { gsap } from 'gsap';
import {
  AfterViewInit, Component, Input,
  Output,
  EventEmitter,
} from '@angular/core';

@Component({
  selector: 'app-expanding-drawer',
  templateUrl: './expanding-drawer.component.html',
  styleUrls: [ './expanding-drawer.component.scss' ],
})
export class ExpandingDrawerComponent implements AfterViewInit {
  @Input() title: string;
  @Input() badge: string;
  @Input() isOpen = false;
  @Input() duration = 0.3;
  @Input() maxDrawerHeight = 'auto';
  @Output() drawerToggled = new EventEmitter<{ isOpen: boolean, animationComplete: boolean }>();

  originalHeight = 0;
  originalPaddingTop = 0;
  originalPaddingBottom = 0;
  originalContentHeight = 0;


  ngAfterViewInit(): void {
    this.handleExpand(this.isOpen, true);
  }

  handleExpand = (isOpen: boolean, initial = false) => {
    const content = document.querySelector('.expanding-drawer-content');
    const carat = document.querySelector('.carat i');
    const header = document.querySelector('.expanding-drawer-header');

    const method = initial ? 'set' : 'to';

    const scrollHeight = content.scrollHeight;
    const computedStyle = window.getComputedStyle(content);
    const paddingTop = parseInt(computedStyle.paddingTop) || 0;
    const paddingBottom = parseInt(computedStyle.paddingBottom) || 0;
    const contentHeight = scrollHeight;

    if (initial) {
      this.originalHeight = contentHeight;
      this.originalPaddingTop = paddingTop;
      this.originalPaddingBottom = paddingBottom;
    }

    const duration = this.duration;

    if (!isOpen) {
      gsap[method](carat, {
        duration, rotate: 0, ease: 'back.out',
      });

      gsap[method](header, {
        borderRadius: '8px',
        duration: duration/2,
        ease: 'linear.inOut',
      });

      gsap[method](content, {
        transformOrigin: 'top',
        height: 0,
        paddingTop: 0,
        paddingBottom: 0,
        pointerEvents: 'none',
        duration,
        ease: 'power2.inOut',
        autoAlpha: 0,
        onComplete: () => {
          this.drawerToggled.emit({ isOpen, animationComplete: true });
        },
      });

    } else {
      gsap[method](carat, {
        duration, rotate: 90, ease: 'back.out',
      });

      gsap[method](header, {
        borderRadius: '8px 8px 0 0',
        duration: duration/2,
        ease: 'linear.inOut',
      });

      gsap[method](content, {
        transformOrigin: 'top',
        height: this.originalHeight,
        paddingTop: this.originalPaddingTop,
        paddingBottom: this.originalPaddingBottom,
        pointerEvents: 'auto',

        duration,
        ease: 'power2.inOut',
        autoAlpha: 1,
        onComplete: () => {
          this.drawerToggled.emit({ isOpen, animationComplete: true });
        },
      });
    }

    this.isOpen = isOpen;
    this.drawerToggled.emit({ isOpen, animationComplete: false });
  }
}
